export default __webpack_public_path__ + "media/images/elements/07-9a4254026ad13949fded4ff16a52fb84.png";